import type { ReactElement } from 'react';

/**
 * 未読・未対応の件数バッジ（D-100）。サイドバーと通知ベルで共通に使う。
 *
 * 形が崩れやすいので、次を守る:
 * - 高さを固定（`h-5`）し、最小幅を同じ値にする（`min-w-5`）→ **1桁のときに正円**になる
 * - `leading-none` と flex の中央揃え → 親の行の高さ（line-height）に引きずられて
 *   数字が上下にずれるのを防ぐ
 * - `tabular-nums` → 数字ごとの字幅の違いで丸の大きさが揺れるのを防ぐ
 * - 3桁以上は `99+` に丸める → 横に伸びてレイアウトが崩れるのを防ぐ
 *
 * 一覧など「未登録」「○ / ○名」と処理箇所が並ぶ画面では `showCount={false}` で
 * 赤丸だけの目印にする（件数はメニュー側で足りる / D-256）。
 */
export function CountBadge({
  count,
  label = '未読',
  className = '',
  showCount = true,
}: {
  count: number;
  /** 読み上げ用のラベル（「未読 3 件」など）。メニューの赤丸は menu.ts の BADGE_LABELS が渡す */
  label?: string;
  className?: string;
  /** false のとき数字なしの赤丸だけ */
  showCount?: boolean;
}): ReactElement | null {
  if (count <= 0) return null;
  if (!showCount) {
    return (
      <span
        aria-label={label}
        className={`inline-block h-2.5 w-2.5 shrink-0 rounded-full bg-wpnotice-error ${className}`}
      />
    );
  }
  return (
    <span
      aria-label={`${label} ${count} 件`}
      className={`inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full bg-wpnotice-error px-1 text-[11px] font-semibold leading-none tabular-nums text-white ${className}`}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
}
